import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { Validator } from '../../../@core/data/model/validator';

import {PermissionService } from '../../../@core/data/rest/permission/permissions-service';
import { Permission } from '../../../@core/data/model/permission';
import { AuthService } from '../../../auth/auth.service';
import { Taxe } from '../../../@core/data/model/taxe';
import { TaxeService } from '../../../@core/data/rest/taxe/taxe-service';
import { plainToClass } from 'class-transformer';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-taxeform',
  templateUrl: './taxeform.component.html' ,
  styles: [`
    button {
      margin: 1rem;
    }
  `],
})
export class TaxeFormComponent implements OnInit {

  @Input() taxeEdit: Taxe;



  constructor(
      protected dialogRef: NbDialogRef<TaxeFormComponent>,
      public taxeService: TaxeService,
      public sharedMethods: SharedMethods,
      public permissionService: PermissionService,
      public authService: AuthService) {
  }


  ngOnInit(): void {

    this.authService.logoutEvent.subscribe(() => {

      this.dialogRef.close();

    });


  }

  onItemSelect(item: any) {

    // tslint:disable-next-line:no-console
    /* for ( let i = 0; i < this.partenaireService.getLocalPartner(this.typePartner).length; i++) {
      if (this.partenaireService.getLocalPartner(this.typePartner)[i].id === item.item_id ) {
        this.facture.partenaire = this.partenaireService.getLocalPartner(this.typePartner)[i];
      }
    } */
    // this.partenaireEdit.plan_tarifaire = item;

  }

  

  cancel() {
    if (this.taxeService.iSconnecting === false) {
      this.dialogRef.close();
    }
  }

  submit() {
    // alert(JSON.stringify(this.partenaireEdit));
    // alert('nature: ' + this.reglementEdit.nature_reglement + ' montant: ' + this.reglementEdit.montant.toString());
    // this.dialogRef.close();

    // this.reglementEdit.date_flux = this.sharedMethods.converNgbDateStructToString(this.dateReglement);

    let valid: Validator;
    valid = this.sharedMethods.validateTaxe(this.taxeEdit, this.taxeService.taxes);

    if (valid.result) {

        // this.dialogRef.close(this.partenaireEdit);

        if (this.taxeService.iSconnecting === false) {

            // console.log(this.userEdit);

            this.taxeService.saveTaxe(this.taxeEdit).then( taxe => {

                // this.taxeEdit.id = user.id;
                this.dialogRef.close(plainToClass(Taxe, taxe as object));
                // alert(JSON.stringify(this.fluxstockedit));

            }, (err) => {

                this.sharedMethods.errorApiShow(err.error.code, err.error.message);

            });
        }

    } else {

        this.sharedMethods.toastShow('error', valid.title, valid.message);

    }


  }

 toggleDirection(newDirection) {
  // this.directionService.setDirection(newDirection);
  // tslint:disable-next-line:no-console
  // console.log(newDirection);
  this.taxeEdit.is_about_h_t = newDirection;
 }


 typeCalculToggleDirection(newDirection) {

    this.taxeEdit.type_calcul = newDirection;

 }


}
